/**
 * ErrorReporting.jsx
 * Created by michaelbray on 2/23/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    item_errors: PropTypes.array
};

export default class ErrorReporting extends React.Component {
    render() {
        if (!this.props.item_errors || this.props.item_errors.length === 0) {
            return <div />;
        }

        const rows = [];
        for (let i = 0; i < this.props.item_errors.length; i++) {
            rows.push(
                <p
                    className="usa-alert-text"
                    key={`item_error_${i}`}>
                    {this.props.item_errors[i]}
                </p>
            );
        }

        return (
            <div className="rec-alert rec-alert-danger" role="alert">
                <div className="rec-alert-header">
                    <div className="h4">
                        <i className="fa fa-exclamation-circle m_R-2x" aria-hidden="true" />
                        {"Error"}
                    </div>
                </div>
                <div className="rec-alert-body">
                    {rows}
                </div>
            </div>
        );
    }
}

ErrorReporting.propTypes = propTypes;
